import { useQuery } from '@tanstack/react-query'
import { api } from 'api'
import { userCardStore } from 'shared/store/userCard'
import { toaster } from 'uikit/Toaster'
import { useEffect } from 'react'

export const useFetchUser = (id: string) => {
  const response = useQuery({
    queryKey: ['userCard', id],
    queryFn: () => {
      return api.users.fetchUserById(id)
    },
  })

  useEffect(() => {
    if (response.isSuccess) {
      userCardStore.setState((state) => ({
        ...state,
        ...response.data,
      }))
    }
  }, [response.isSuccess, response.data])

  useEffect(() => {
    if (response.isError) {
      toaster.create({
        type: 'error',
        title: 'Ошибка загрузки данных пользователя',
        description: response.error?.message,
      })
    }
  }, [response.isError])

  return response
}
